window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
/**
 * lpAjax namespace
 * @namespace - contains the lpAjax logic
 */
lpTag.taglets.lpAjax = lpTag.taglets.lpAjax || (function (window) {
    var version = "1.1.3",
        name = "lpAjax",
        containerName = "lpTransporter",
        _transports = {},
        isInit = false,
        logTypes = { ERROR: "ERROR", DEBUG: "DEBUG", INFO: "INFO", METRICS:"METRICS"},
        rndUID  = "lpT" + Math.floor(Math.random() * 100000) + "_" + Math.floor(Math.random() * 1000000);

    function init() {
        isInit = true;
    }

    function _log(msg, type) {
        if (window.lpTag && lpTag.log) {
            lpTag.log(msg, type, name);
        }
    }

    function addTransport(name, transport) {
        if(!_transports[name]) {
            _transports[name] = transport;
            _log("Added transport: " + name, logTypes.DEBUG);
        }else{
            _log("Existing transport: " + name + " tried to register", logTypes.DEBUG);
        }
    }

    function issueCall(request) {
        if (!isInit) { init(); }
        var transport;
        var tname = 'unknown';

        try {
            transport = _chooseTransport(request);
            if(transport){
                transport.issueCall(request);
                return true;
            }else{
                _log("No Transport found to issueCall", logTypes.ERROR);
                runCallBack(logTypes.ERROR, request.error, { responseCode: 601, error: "No Transport found to issueCall, request: " + request.url, body: "ERROR" }, request.context);
            }
        }
        catch (e) {
            if (transport && transport.getName) {
                tname = transport.getName();
            }
            _log("Transport - " + tname + " - unknown exception while issueCall", logTypes.ERROR);
            runCallBack(logTypes.ERROR, request.error, { responseCode: 600, error: "Transport - " + tname + " - unknown exception while issueCall: " + request.url + " e=" + e, body: "ERROR" }, request.context);
        }
    }

    function configureTransports(confT) {
        if (!isInit) { init(); }

        for (var name in confT) {
            var t = _transports[name];
            if (t) {
                t.configure(confT[name]);
            }
        }
    }

    function publishMetrics(rawDataObj){
        if(rawDataObj && typeof rawDataObj === 'object') {
            rawDataObj.appName = containerName;
            rawDataObj.ts = new Date().getTime();
            if(rawDataObj.tags && rawDataObj.tags.constructor === Array){
                rawDataObj.tags.push({ pageId: rndUID });
            }
            _log(rawDataObj, logTypes.METRICS);
        }
    }

    function _chooseTransport(reqObj) {
        var foundT = false, index = -1;
        var req;
        for (var i=0; i<reqObj.transportOrder.length; i++) {
            if(!foundT){
                req = extend({} , reqObj);
                var t = _transports[req.transportOrder[i]];
                if (t && t.isValidRequest && t.isValidRequest(req)) {
                    foundT = true;
                    index = i;
                }
            }
        }
        if(foundT){
            return _transports[req.transportOrder[index]];
        }else{
            return null;
        }
    }

    /**
     * An `each` implementation, aka `forEach`<br>
     * Handles objects with the built-in `forEach`, arrays, and raw objects<br>
     * Delegates to **ECMAScript 5**'s native `forEach` if available
     * @param {Object} obj list of elements
     * @param {Object} iterator
     * @param {Object} context
     * @example
     * lpTag.taglets.lpajax_utils.each([1, 2, 3], function(num){ alert(num); });
     * result: alerts each number in turn...
     * lpTag.taglets.lpajax_utils.each({one : 1, two : 2, three : 3}, function(num, key){ alert(num); });
     * result: alerts each number in turn...
     */
     function each(obj, iterator, context) {
        if (obj == null) {return;}
        var nativeForEach = Array.prototype.forEach;

        if (nativeForEach && obj.forEach === nativeForEach) {
            obj.forEach(iterator, context);
        }
        else if (obj.length === +obj.length) {
            for (var i = 0, l = obj.length; i < l; i++) {
                if (i in obj && iterator.call(context, obj[i], i, obj) === {}) {return;}
            }
        } else {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    if (iterator.call(context, obj[key], key, obj) === {}) {return;}
                }
            }
        }
    }
    /**
     * Copy all of the properties in the source objects over to the destination object, and return the destination object.<br>
     * It's in-order, so the last source will override properties of the same name in previous arguments
     *
     * @param {Object} obj a request object (see lpAjax for detailed description)
     * @example
     * lpTag.taglets.lpajax_utils.extend(destination, *sources)
     * lpTag.taglets.lpajax_utils.extend({name : 'moe'}, {age : 50});
     * result: {name : 'moe', age : 50}
     */
     function extend(obj) {
        each(Array.prototype.slice.call(arguments, 1),
            function(source) {
                for (var prop in source) {
                    obj[prop] = source[prop];
                }
            }
        );
        return obj;
    }

    /**
     * Runs the callback passed protected
     * @param type - the function type for logging purposes
     * @param callback - the function that needs to run
     * @param data - the data passed on to that function
     * @param context - the context if any ti run this in
     */
    function runCallBack(type, callback, data, context) {
        if (typeof callback === 'function') {
            try {
                callback.call(context || null, data);
                callback = null;
            } catch (e) {
                _log("runCallback: Exception in execution of callback, type :" + type + " e=[" + e.message + "]", logTypes.ERROR);
            }
        } else {
            _log("runCallBack: No callback, of type :" + type, logTypes.INFO);
        }
    }


    return {
        getVersion: function () { return version; },
        getName: function () { return name; },
        init : init,
        publishMetrics: publishMetrics,
        issueCall : issueCall,
        configureTransports : configureTransports,
        addTransport : addTransport
    };
})(window);

/*** EXPORTS FROM exports-loader ***/
module.exports = lpTag.taglets.lpAjax;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lp-transporter/src/lpajax.js
// module id = 390
// module chunks = 0